module.exports = __webpack_public_path__ + "static/img/ISO9001.a08df996.png";